import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import formatCommentTime from '@functions/formatCommentTime'

import { useRelations } from '@hooks/useConversation'

import type { ConversationModel } from '@models/types'

type SelectListItemParams = {
  campaignId: number,
  conversation: ConversationModel,
}

const selectListItem = (params: SelectListItemParams) => {
  const { campaignId, conversation } = params

  const prefix = `campaigns/${campaignId}/edit`
  window.location.hash = `#/${prefix}/conversations/${conversation.id}`
}

type ListProps = {
  campaignId: number,
  conversation: ConversationModel,
}

const ConversationListItem = (props: ListProps) => {
  const {
    campaignId,
    conversation: {
      title,
      unread_count,
    },
    conversation,
  } = props

  const { lastComment } = useRelations(conversation)

  const body = digObject(lastComment, 'body', '')

  return (
    <DashboardModuleListItem
      onClick={() => selectListItem({ campaignId, conversation })}
      // @ts-expect-error TS2322
      showAngleIcon={unread_count === 0}
      secondaryText={body}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText textProps={{ textAlign: 'right' }}>
        <Box maxHeight="300">
          {/*
           // @ts-expect-error TS2739 */}
          <Text>{formatCommentTime({ lastComment, conversation })}</Text>

          {!!unread_count && (
            <Text fontSize="xsmall" paddingLeft="medium" color="blue">
              <FontAwesomeIcon icon={faCircle} />
            </Text>
          )}
        </Box>
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default ConversationListItem
